import {useEffect, useState} from "react";
import {Checkbox, FormControlLabel} from "@mui/material";
import "./index.scss";
import VLFSelectNew from "@/components/Input/SelectNew";
import {VenueAPI} from "@/api/venue";
import {getInternalClubId, ERROR_OPERATION} from "@/utils/constants";
export default function VenueSelect({
	value,
	onChange,
	training = false,
	associationClubId = null,
	handleNotification,
	...props
}) {
	const [venues, setVenues] = useState([]),
		[showAll, setShowAll] = useState(false),
		[creating, setCreating] = useState(false);
	useEffect(() => {
		VenueAPI.list()
			.then((data) => setVenues(data || []))
			.catch(() => handleNotification?.(ERROR_OPERATION, "error"));
	}, [handleNotification]);
	const createVenue = async (input) => {
		const name = input.trim();
		if (!name) return;
		setCreating(true);
		try {
			const all = (await VenueAPI.list()) || [];
			let venue = all.find(
				(v) => v.name.trim().toLowerCase() === name.toLowerCase(),
			);
			if (!venue) {
				const clubId =
					associationClubId || (training ? getInternalClubId() : null);
				try {
					venue = await VenueAPI.create({
						name,
						address: null,
						clubIds: clubId ? [clubId] : [],
					});
				} catch (error) {
					const latest = await VenueAPI.list();
					venue = (latest || []).find(
						(v) => v.name.trim().toLowerCase() === name.toLowerCase(),
					);
					if (!venue) throw error;
				}
			}
			setVenues([...all.filter((v) => v.id !== venue.id), venue]);
			onChange({value: venue.id, label: venue.name, address: venue.address});
		} catch (error) {
			handleNotification?.(
				error.response?.data?.error || ERROR_OPERATION,
				"error",
			);
		} finally {
			setCreating(false);
		}
	};
	const options = venues
		.filter(
			(v) =>
				!training ||
				showAll ||
				v.clubIds.includes(getInternalClubId()) ||
				v.id === value?.value,
		)
		.map((v) => ({value: v.id, label: v.name, address: v.address}));
	return (
		<div
			className={
				training ? "venue-select venue-select--training" : "venue-select"
			}
		>
			<div className="venue-select__field">
				<VLFSelectNew
					{...props}
					label="Campo"
					options={options}
					value={value}
					onChange={onChange}
					onCreateOption={createVenue}
					formatCreateLabel={(name) => `Crea campo "${name}"`}
					isLoading={creating}
					isDisabled={creating || props.isDisabled}
					placeholder={
						training && !showAll && !options.length
							? "Associa un campo al tuo club o mostra tutti i campi"
							: "Seleziona..."
					}
				/>
			</div>
			{training && (
				<FormControlLabel
					className="venue-select__all"
					control={
						<Checkbox
							size="small"
							checked={showAll}
							onChange={(e) => setShowAll(e.target.checked)}
						/>
					}
					label="Mostra tutti i campi"
				/>
			)}
		</div>
	);
}
